import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, Input, SimpleChanges} from '@angular/core';
import {CallTypeDto} from "../../../model/dto/entity/call-type.dto";
import {CustomerContactPhoneInfoDto} from "../../../../cr/model/dto/api/customer-contact-phone-info.dto";
import {CustomerContactService} from "../../../../cr/service/api/customer-contact.service";
import {CallService} from "../../../service/api/call.service";
import {CoChannelPhoneNumberDto} from "../../../../../feature-core/co/model/dto/api/co-channel-phone-number.dto";
import {CallDto} from "../../../model/dto/entity/call.dto";
import {ConfirmationService} from "primeng/api";
import {CallUiService} from "../../../service/ui/call-ui.service";
import {CoUiService} from "../../../../../feature-core/co/service/ui/co-ui.service";
import {
    CoChannelContactGuardService
} from "../../../../../feature-core/co/service/ui/co-channel-contact-guard.service"; // TM-1000002005
import {CoChannelAccessTypeEnum} from "../../../../../feature-core/co/enum/co-channel-access-type-enum.enum";
import {CoChannelTypeEnum} from "../../../../../feature-core/co/enum/co-channel-type-enum.enum";
import {
    CoUiChannelAccessTypeInfoUi
} from "../../../../../feature-core/co/model/dto/api/co-ui-channel-access-type-info.ui";
import {CallDirectionEnum} from "../../../enum/call-direction-enum.enum";
import {CallRecipientTypeEnum} from "../../../enum/call-recipient-type-enum.enum";
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestSimple} from "../../../../../core/shared/dto/object/request/object-request-simple";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../core/shared/misc/sorting";

@Component({
    selector: 'mvs-pc-call-dial',
    templateUrl: './pc-call-dial.component.html',
    standalone: false
})
export class PcCallDialComponent {

    callTypeService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() calledObject: ObjectIdentifier;        // <Object Alias>: cr.Customer / <ID>: ID of Object
    @Input() callTypeId: number;                    // <Call Type ID>: 1
    @Input() callTypeDto?: CallTypeDto;

    @Input() sourceActionObject?: ObjectIdentifier;

    uiChannelAccessInfo?: CoUiChannelAccessTypeInfoUi;
    uiPreferredIconClass: string = 'fa-solid fa-heart';

    customerContactPhoneInfo: CustomerContactPhoneInfoDto;

    listOutgoingCallTypeDtoList: DtoList<CallTypeDto>;
    selectedCallType: CallTypeDto;

    constructor(
        protected coreService: MvsCoreService,
        
        protected customerContactService: CustomerContactService,
        protected callService: CallService,
        protected confirmationService: ConfirmationService,
        protected callUiService: CallUiService,
        protected coUiService: CoUiService,
        protected messageService: MvsMessageService,
        protected contactGuardService: CoChannelContactGuardService) {
        this.callTypeService = this.coreService.getCrudService("pc.CallType");

    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {

        // retrieve all outgoing call types
        this.callTypeService.list(
            ObjectRequestList.createSimpleRequestList(
                false,
                ObjectRequestSimple.create(false, false, 0),
                [FilterCriteria.create("callDirection", FilterCriteria.cOperatorEqual, CallDirectionEnum.outgoing),
                            FilterCriteria.create("callRecipientType", FilterCriteria.cOperatorEqual, CallRecipientTypeEnum.customer)],
                [ new Sorting("orderPriority", true)],
                null,
                null)).subscribe(value => {

                    this.listOutgoingCallTypeDtoList = value;

                    if (this.listOutgoingCallTypeDtoList && this.listOutgoingCallTypeDtoList.entries && this.listOutgoingCallTypeDtoList.entries.length > 0) {
                        this.selectedCallType = this.listOutgoingCallTypeDtoList.entries[0];
                    }

                    this.refreshComponent();
        });

    }

    refreshUi() {

        this.uiChannelAccessInfo = this.getCallAccessInformation(this.customerContactPhoneInfo.channelAccess);

        if (!this.customerContactPhoneInfo.recipientAddresses) {
            return;
        }

        for (let recipientAddress of this.customerContactPhoneInfo.recipientAddresses) {
            recipientAddress.uiChannelAccessInfo = this.uiChannelAccessInfo;

            if (recipientAddress.preferred) {
                // put in star ....
            }

        }

        this.initialized = true;

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        if(this.calledObject.objectType === 'cr.Customer') {
            this.customerContactService.getPhoneInfo(this.calledObject.objectId).subscribe(value => {
                this.customerContactPhoneInfo = value;

                this.refreshUi();
            });
        }

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["calledObject"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    callDto: CallDto;

    handleStartCall(recipientAddress: CoChannelPhoneNumberDto) {

        if (!this.selectedCallType) {
            this.messageService.showErrorMessage("Typ auswählen", "Bitte Anruftyp auswählen!");
            return;
        }

        // check for active call
        this.callService.getMyActiveCalls().subscribe(activeCalls => {

            if (activeCalls && activeCalls.entries && activeCalls.entries.length > 0) {
                this.messageService.showErrorMessage("Laufender Anruf", "Bitte aktuellen Anruf zuerst beenden!");
            } else {
                this.callService.startCustomerCall(this.selectedCallType.id,this.calledObject.objectId, recipientAddress.phoneNumber).subscribe(value => {
                    this.callDto = value;
                    this.callUiService.refreshHeaderActiveCall();
                });
            }
        });

    }

    protected getCallAccessInformation(access: CoChannelAccessTypeEnum): CoUiChannelAccessTypeInfoUi {

        return this.coUiService.getChannelAccessTypeInfo(access);

    }

    /**
     * Ask before dialling, when there is something to ask about.
     *
     * <h3>TM-1000002005 - it used to ask ALWAYS, and often about nothing</h3>
     * The previous body opened a confirmation unconditionally, carrying
     * {@code uiChannelAccessInfo.message} - which is the EMPTY STRING for every granted access. On an
     * ordinary customer that produced a dialog with no sentence in it, and a dialog that appears when
     * there is nothing to confirm is worse than none: the next one is clicked away unread too.
     *
     * <p>It now asks the same question every other channel-initiating action asks
     * ({@code CoChannelContactGuardService}), which also covers the customer level
     * Kommunikationssperre the channel access cannot express. The consultant variant no longer needs
     * an override - this body is the one both of them use.</p>
     */
    confirmStartCall(e: Event, recipientAddress: CoChannelPhoneNumberDto) {

        this.contactGuardService.confirmContact(
            this.calledObject,
            CoChannelTypeEnum.call,
            {acceptLabel: 'Trotzdem anrufen'},
            () => this.handleStartCall(recipientAddress));
    }
}
